import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-brand">
              <span className="brand-logo">PS</span>
              <span className="brand-text">Trivnu</span>
            </div>
            <p className="footer-description">
              Transforming visions into exceptional projects. We deliver professional 
              development services that exceed expectations.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('hero')}>Home</button></li>
              <li><button onClick={() => scrollToSection('services')}>Services</button></li>
              <li><button onClick={() => scrollToSection('about')}>About</button></li>
              <li><button onClick={() => scrollToSection('enquiry')}>Get Quote</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Services</h4>
            <ul className="footer-links">
              <li>Project Planning</li>
              <li>Development</li>
              <li>Design & UI/UX</li>
              <li>Quality Assurance</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact</h4>
            <ul className="footer-contact">
              <li>📧 Sales@trivnu.com</li>
              <li>📱 +91 (702) 166-8565</li>
              <li>📱 +91 (858) 283-2409</li>
              <li>📍 SEZ Greater Noida, IN</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Trivnu Solutions. All rights reserved.</p>
          {/* <div className="footer-social">
            <a href="#" aria-label="LinkedIn">LinkedIn</a>
            <a href="#" aria-label="Twitter">Twitter</a>
            <a href="#" aria-label="Facebook">Facebook</a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
